import AppBar from '@material-ui/core/AppBar';
import { StylesProvider } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';

import Render from 'components/render';
import { RenderByExchange } from 'components/render/RenderByExchangeType';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import { isFutures } from 'helpers/utils';
import Box from 'UIKit/Box';

import SearchMarkets from '../../search';
import FuturesVolumeBox from '../24HourVolumeBox/FuturesVolumeBox';
import DownloadVolumeData from '../DownloadVolumeData/DownloadVolumeData';
import { SelectableTag } from './constants';
import styles from './futuresStrip.module.scss';

interface SearchProps {
  onSearchChange: (value: string) => void;
  searchTerm: string;
  noProducts: boolean;
  handleOnClick: () => void;
  reset: () => void;
}

interface FuturesTabStripProps {
  selectedTag: SelectableTag;
  setSelectedTag: (param: string) => void;
  activeProductsTags: SelectableTag[];
  selectedContractType: string;
  searchProps?: SearchProps;
}

const trackSelectedCoinTag = (tagId: string) => {
  trackMixpanelEvent('All Markets Page - Coin tag selected ', {
    tag: tagId,
  });
};

const FuturesTabStrip = ({
  selectedTag,
  activeProductsTags,
  setSelectedTag,
  selectedContractType,
  searchProps,
}: FuturesTabStripProps) => {
  const { t } = useTranslation(['markets']);
  const { onSearchChange, searchTerm, noProducts, handleOnClick, reset } =
    searchProps || {};

  const handleChange = (_, newValue) => {
    setSelectedTag(newValue);
    trackSelectedCoinTag(newValue);
  };

  return (
    <Render when={selectedContractType && isFutures(selectedContractType)}>
      <div className={styles.futuresStrip}>
        <div className={styles.filtersContainer}>
          {/* <MediaQuery query={device.up.md}>
            <AssetTypeDropDown
              assetType="settling"
              handleDropDownChange={filterBySettlingAsset}
              selectedAsset={settlingAsset}
            />
          </MediaQuery> */}
          <Box className={styles.tagsContainer}>
            <StylesProvider injectFirst>
              <AppBar position="static" color="default" className={styles.header}>
                <Tabs
                  className={styles.root}
                  value={selectedTag}
                  onChange={handleChange}
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable auto tabs example"
                  classes={{
                    root: styles.tabs,
                    flexContainer: styles.flexContainer,
                    indicator: styles.indicator,
                    scrollButtons: styles.scrollButton,
                  }}
                  data-testid="TagNavigator"
                >
                  {activeProductsTags.map(currentTag => {
                    return (
                      <Tab
                        label={t(`markets:marketsTable.tags.${currentTag}`)}
                        id={`scrollable-auto-tab-${currentTag}`}
                        aria-controls={`scrollable-auto-tabpanel-${currentTag}`}
                        classes={{ root: styles.tab }}
                        value={currentTag}
                        key={currentTag}
                      />
                    );
                  })}
                </Tabs>
              </AppBar>
            </StylesProvider>
          </Box>
        </div>

        <MediaQuery query={device.up.md}>
          <div className={styles.rowControl}>
            {/* <TryEasyOptionsButton mixpanelSource="Markets Table" /> */}

            <RenderByExchange
              global={
                <>
                  <DownloadVolumeData />
                  <FuturesVolumeBox />
                </>
              }
              indian={
                <SearchMarkets
                  data-testid="DesktopSearchBar-MarketsPage"
                  search={onSearchChange}
                  searchValue={searchTerm}
                  noProducts={noProducts}
                  onClick={handleOnClick}
                  reset={reset}
                />
              }
            />
          </div>
        </MediaQuery>
      </div>
    </Render>
  );
};

export default FuturesTabStrip;
